import { GOAL_CHIPS } from "../config";

export default function GoalsStep({ profile, saveField }) {
  const goals = profile.career_goals || [];
  const toggle = (g) => {
    const active = goals.includes(g);
    saveField({ career_goals: active ? goals.filter((x) => x !== g) : [...goals, g] });
  };
  return (
    <div>
      <div className="text-xs text-muted-foreground mb-3">Pick as many as apply.</div>
      <div className="flex flex-wrap gap-2">
        {GOAL_CHIPS.map((g) => {
          const active = goals.includes(g);
          return (
            <button
              key={g}
              data-testid={`onboarding-goal-${g.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={() => toggle(g)}
              className={`px-3 py-1.5 rounded-full text-sm font-medium transition-all ${
                active
                  ? "bg-primary text-primary-foreground"
                  : "bg-secondary text-secondary-foreground hover:bg-accent"
              }`}
            >
              {g}
            </button>
          );
        })}
      </div>
    </div>
  );
}
